import { ButtonAppearance, ButtonSize, Icon, IconSize, TextFieldSize } from '@bechtel/gds';
import { EditCountButtonStyled, EditCountFieldStyled, EditCountTextFieldStyled } from './styled';

interface EditCountFieldProps {
  count: number;
  onIncrement?: () => void;
  onDecrement?: () => void;
  onCountTextChange?: (count: number) => void;
  onHandCount?: number | null;
  btnDisabled?: boolean;
  minusBtnDisable?: boolean;
  plusBtnDisable?: boolean;
  isPickedError?: boolean;
}

export const EditCountField: React.FC<EditCountFieldProps> = ({
  count,
  onIncrement,
  onDecrement,
  onCountTextChange,
  onHandCount,
  btnDisabled = false,
  minusBtnDisable = false,
  plusBtnDisable = false,
  isPickedError = false,
}) => {
  btnDisabled = btnDisabled || onHandCount === 0;
  return (
    <EditCountFieldStyled
      itemCount={count}
      btnDisabled={btnDisabled}
      itemOnHandCount={onHandCount}
      flexShrink={{ sm: '0' }}
      isPickedError={isPickedError}
    >
      <EditCountButtonStyled
        disabled={btnDisabled || minusBtnDisable}
        appearance={ButtonAppearance.TERTIARY}
        size={ButtonSize.SMALL}
        isPickedError={isPickedError}
        onClick={() => {
          onDecrement && onDecrement();
        }}
      >
        <Icon icon="minus" iconStyle="regular" size={IconSize.SMALL} fillColor="blue.800" />
      </EditCountButtonStyled>
      <EditCountTextFieldStyled
        disabled={btnDisabled}
        size={TextFieldSize.SMALL}
        maxLength={5}
        value={count}
        isPickedError={isPickedError}
        onChange={(e) => {
          if (onCountTextChange) {
            if (!e.target.value) onCountTextChange(0);
            if (Number(e.target.value)) {
              onCountTextChange(Number(e.target.value));
            }
          }
        }}
      ></EditCountTextFieldStyled>
      <EditCountButtonStyled
        disabled={btnDisabled || plusBtnDisable}
        appearance={ButtonAppearance.TERTIARY}
        size={ButtonSize.SMALL}
        isPickedError={isPickedError}
        onClick={() => {
          onIncrement && onIncrement();
        }}
      >
        <Icon icon="plus" iconStyle="regular" size={IconSize.SMALL} fillColor="blue.800" />
      </EditCountButtonStyled>
    </EditCountFieldStyled>
  );
};
